'use client';

import type { SexSchema } from '@coas/validators/const';
import { useSetAtom } from 'jotai';
import type { PropsOf } from '~/shared/lib';
import { searchStateAtom } from '../model/state';

type SearchTriggerProps = Omit<PropsOf<'button'>, 'onClick'> & {
    sex?: SexSchema;
};

export default (props: SearchTriggerProps) => {
    const setState = useSetAtom(searchStateAtom);

    return (
        <button
            {...props}
            type={props.type ?? 'button'}
            onClick={e => {
                if (e.detail !== 0) e.currentTarget.blur();
                setState(prev => ({ ...prev, open: true }));
            }}
        />
    );
};
